import TransactionListCustomActionCell from '@/modules/transaction/components/table/TransactionListCustomActionCell.vue'
import ColorCell from '@/onenetwork/components/datatable/ColorCell.vue'
import DateTimeCell from '@/onenetwork/components/datatable/DateTimeCell.vue'
import MoneyCell from '@/onenetwork/components/datatable/MoneyCell.vue'
import PhoneCell from '@/onenetwork/components/datatable/PhoneCell.vue'
import TagCell from '@/onenetwork/components/datatable/TagCell.vue'
import TextCell from '@/onenetwork/components/datatable/TextCell.vue'
import AccountCell from '@/onenetwork/components/datatable/AccountCell.vue'
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant.ts'
import { buildFilterObject } from '@/utils/filter'
import { defineStore } from 'pinia'
import { markRaw } from 'vue'
import { uuid } from 'vue3-uuid'
import { formatTableDataConsultations } from '../helper/table'
import { ConsultationsAPI } from '../constants/consultations.api.uri.const'
import { parseFilter } from '@/utils/filterHelper.ts'


export enum ConsultationsListActionTypes {
  FILTERING = 'FILTERING',
  PENDING = 'PENDING',
  FETCHING = 'FETCHING',
  FETCH_SUCCESS = 'FETCH_SUCCESS',
  FETCH_FAILURE = 'FETCH_FAILURE',
}

interface ConsultationsListStore {
  action_type: ConsultationsListActionTypes
  action_mess: string
  uuid: string
  data: Object
  filter: Object
  pageSize: number
  page: number
  tableConfig: Object
  selectedIds: Array<string | number>
}

export const useConsultationsListStore = defineStore('consultations.list', {
  state: (): ConsultationsListStore => ({
    action_type: ConsultationsListActionTypes.PENDING,
    action_mess: '',
    uuid: '',
    data: {
      list: [],
      totalRecords: 0,
      totalPage: 0,
    },
    filter: [
      {
        key: 'code',
        type: 'text',
        label: 'Mã tài khoản',
        placeholder: 'Nhập mã tài khoản',
        value: '',
      },
      {
        key: 'keyword',
        type: 'taginput',
        label: 'Lọc theo từ khoá',
        placeholder: 'Nhập từ khoá',
        value: '',
      },
    ],
    pageSize: 10,
    page: 1,
    tableConfig: {
      canShowHide: true,
      columns: {
        code: { label: 'Mã yêu cầu', component: markRaw(TextCell), visible: true, sort: false, config: {} },
        status: { label: 'Trạng thái', component: markRaw(TagCell), visible: true, sort: false, config: {} },
        code_real_estate: { label: 'Mã bất động sản', component: markRaw(TextCell), visible: true, sort: false, config: {} },
        code_listing: { label: 'Mã tin mua bán', component: markRaw(TextCell), visible: true, sort: false, config: {} },
        customer: { label: 'Khách hàng', component: markRaw(AccountCell), visible: true, sort: false, config: {} },
        content: { label: 'Nội dung yêu cầu', component: markRaw(TextCell), visible: true, sort: false, config: {} },
        deliveries_count: { label: 'Đã phân phối', component: markRaw(TextCell), visible: true, sort: false, config: {} },
        broker: { label: 'Môi giới được chọn', component: markRaw(AccountCell), visible: true, sort: false, config: {} },
        created_at: {
          label: 'Ngày đăng kí yêu cầu',
          component: markRaw(DateTimeCell),
          visible: true,
          sort: false,
          config: {},
        },
        approved_at: {
          label: 'Ngày xác nhận yêu cầu',
          component: markRaw(DateTimeCell),
          visible: true,
          sort: false,
          config: {},
        },
      },
    },
    selectedIds: [],
  }),
  getters: {
    sortFilter: (state) => {
      const sort: any = []
      if (Object.keys(state.tableConfig?.columns).length > 0) {
        Object.keys(state.tableConfig?.columns).forEach((col) => {
          if (state.tableConfig.columns[col].sort) {
            sort.push([col, state.tableConfig.columns[col].sort])
          }
        })
      }
      return sort
    },
  },
  actions: {
    //FILTER ACTION
    setFilter(filter: any) {
      this.filter = filter
      this.page = 1
      this.action_type = ConsultationsListActionTypes.FILTERING
      this.uuid = uuid.v4()
    },
    putFilter(key: string, value: any) {
      this.filter = this.filter.map((field) => {

        if (field.type === 'select-multiple') {
          if (field.key === key) {
            const newValue = Array.isArray(value) ? value : [value]
            return { ...field, value: newValue }
          }
          return field
        }
        if (field.key === key) {
          return { ...field, value: value }
        }
        return field
      })
      this.page = 1
      this.action_type = ConsultationsListActionTypes.FILTERING
      this.uuid = uuid.v4()
    },

    resetFilter () {
      this.filter = this.filter.map(item => ({...item, value: ''}))
      this.page = 1
      this.action_type = ConsultationsListActionTypes.FILTERING
      this.uuid = uuid.v4()
    },

    //PAGE ACTION
    changePage(page: number) {
      this.page = page
      this.action_type = ConsultationsListActionTypes.FILTERING
      this.uuid = uuid.v4()
    },
    changePageSize(size: number) {
      this.pageSize = size
      this.action_type = ConsultationsListActionTypes.FILTERING
      this.uuid = uuid.v4()
    },

    //TABLE CONFIG ACTION
    toggleColumnVisibility(columnCode: string, visible: boolean) {
      if (this.tableConfig?.columns[columnCode]) {
        this.tableConfig.columns[columnCode].visible = visible
      } else {
        console.warn(`Column "${columnCode}" không tồn tại trong tableConfig`)
      }
    },
    toggleSort(columnCode: string, sort: string) {
      if (this.tableConfig?.columns[columnCode]) {
        this.tableConfig.columns[columnCode].sort = sort
        this.action_type = ConsultationsListActionTypes.FILTERING
        this.uuid = uuid.v4()
      } else {
        console.warn(`Column "${columnCode}" không tồn tại trong tableConfig`)
      }
    },

    //DATA ACTION
    async fetchList() {
      return new Promise(async (resolve, reject) => {
        try {
          this.action_type = ConsultationsListActionTypes.FETCHING
          const sort = this.sortFilter
          const pagination = {
            page: this.page,
            page_size: this.pageSize,
            // sort,
          }

          const filter = parseFilter(this.filter)
          const res = await APIClient.get(ConsultationsAPI.consultations.list, {
            params: {...filter, sort, ...pagination},
          })
          const { data } = res.data

          this.data = {
            list: formatTableDataConsultations(data.data) || [],
            totalRecords: data.total ?? 0,
            totalPage: data.last_page ?? 0
          }
          this.action_type = ConsultationsListActionTypes.FETCH_SUCCESS
          resolve(res)
        } catch (e) {
          this.action_type = ConsultationsListActionTypes.FETCH_FAILURE
          reject(e)
        }
      })
    },
  },
})
